<h4 mat-dialog-title translate>technicalInspection.bankOps.title</h4>

<mat-dialog-content>
  <ng-container *ngIf="refundEligible; else nonRefundMode">
    <p class="text-muted small" translate>technicalInspection.bankOps.refund.sectionTitle</p>

    <div class="input-group mb-2">
      <div class="input-group-prepend">
        <span class="input-group-text" translate>technicalInspection.bankOps.orderNumber</span>
      </div>
      <input type="text" class="form-control" [value]="data.orderNumber || ''" disabled>
    </div>
    <div class="input-group mb-2">
      <div class="input-group-prepend">
        <span class="input-group-text" translate>technicalInspection.bankOps.refund.totalAmount</span>
      </div>
      <input type="text" class="form-control" [value]="data.orderTotalAmount" disabled>
    </div>
    <div class="input-group mb-2">
      <div class="input-group-prepend">
        <span class="input-group-text" translate>technicalInspection.bankOps.refund.paymentStatus</span>
      </div>
      <input type="text" class="form-control" value="PAID" disabled>
    </div>
    <div class="input-group mb-2">
      <div class="input-group-prepend">
        <span class="input-group-text" translate>technicalInspection.bankOps.paymentDate</span>
      </div>
      <input type="text" class="form-control" [value]="data.existingPaymentDate || ''" disabled>
    </div>
    <div class="input-group mb-2">
      <div class="input-group-prepend">
        <span class="input-group-text" translate>technicalInspection.transactionIdentifier</span>
      </div>
      <input type="text" class="form-control" [value]="data.existingTransactionNumber || ''" disabled>
    </div>

    <div *ngIf="refundsLoaded && existingRefunds.length > 0" class="mt-3">
      <h6 translate>technicalInspection.bankOps.refund.existingTitle</h6>
      <table class="table table-sm table-bordered">
        <thead>
          <tr>
            <th translate>technicalInspection.bankOps.refund.type</th>
            <th translate>technicalInspection.bankOps.refund.amount</th>
            <th translate>technicalInspection.bankOps.refund.reason</th>
            <th translate>technicalInspection.bankOps.paymentDate</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of existingRefunds">
            <td>{{ r.refundTypeName }}</td>
            <td>{{ r.totalAmount }}</td>
            <td>{{ r.reason }}</td>
            <td>{{ r.refundedAt }}</td>
          </tr>
        </tbody>
      </table>
      <div class="text-muted small">
        <span translate>technicalInspection.bankOps.refund.remaining</span>: {{ remaining }}
      </div>
    </div>

    <div *ngIf="!refundFormVisible && canAddRefund" class="mt-2">
      <button type="button" class="btn btn-success" (click)="showAddRefund()" translate>
        technicalInspection.bankOps.refund.addButton
      </button>
    </div>

    <div *ngIf="refundFormVisible" class="mt-3 p-2 border rounded">
      <form [formGroup]="refundForm" (ngSubmit)="submitRefund()">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <span class="input-group-text" translate>technicalInspection.bankOps.refund.type</span>
          </div>
          <select class="custom-select" formControlName="refundTypeId" (change)="onRefundTypeChange()">
            <option [ngValue]="null" translate>placeholder.select</option>
            <option [ngValue]="REFUND_TYPE_FULL" translate>technicalInspection.bankOps.refund.typeFull</option>
            <option [ngValue]="REFUND_TYPE_PARTIAL" translate>technicalInspection.bankOps.refund.typePartial</option>
          </select>
        </div>

        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <span class="input-group-text" translate>technicalInspection.bankOps.refund.amount</span>
          </div>
          <input type="number" step="0.01" class="form-control" formControlName="amount">
        </div>

        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <span class="input-group-text" translate>technicalInspection.bankOps.refund.reason</span>
          </div>
          <textarea class="form-control" formControlName="reason" rows="3" maxlength="1000"></textarea>
        </div>

        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-outline-secondary mr-2"
                  (click)="cancelAddRefund()" [disabled]="submitting" translate>button.cancel</button>
          <button type="submit" class="btn btn-success"
                  [disabled]="refundForm.invalid || submitting" translate>
            technicalInspection.bankOps.refund.save
          </button>
        </div>
      </form>
    </div>
  </ng-container>

  <ng-template #nonRefundMode>
    <div *ngIf="hasValidExistingTransaction; else enterTransaction">
      <p class="text-muted small" translate>technicalInspection.bankOps.alreadyPaidHint</p>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <span class="input-group-text" translate>technicalInspection.bankOps.orderNumber</span>
        </div>
        <input type="text" class="form-control" [value]="data.orderNumber || ''" disabled>
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <span class="input-group-text" translate>technicalInspection.transactionIdentifier</span>
        </div>
        <input type="text" class="form-control" [value]="data.existingTransactionNumber" disabled>
      </div>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <span class="input-group-text" translate>technicalInspection.bankOps.paymentDate</span>
        </div>
        <input type="text" class="form-control" [value]="data.existingPaymentDate" disabled>
      </div>
    </div>
    <ng-template #enterTransaction>
      <p class="text-muted small" translate>technicalInspection.bankOps.hint</p>
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <span class="input-group-text" translate>technicalInspection.bankOps.orderNumber</span>
        </div>
        <input type="text" class="form-control" [value]="data.orderNumber || ''" disabled>
      </div>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <span class="input-group-text" translate>technicalInspection.transactionIdentifier</span>
          </div>
          <input type="text" class="form-control" formControlName="transactionId"
                 maxlength="30" autocomplete="off" autofocus>
        </div>
      </form>
    </ng-template>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="btn btn-outline-secondary mr-2"
          (click)="onCancel()" [disabled]="submitting" translate>button.cancel</button>
  <button *ngIf="!refundEligible && !hasValidExistingTransaction" type="button" class="btn btn-success"
          (click)="onSubmit()"
          [disabled]="form.invalid || submitting" translate>
    technicalInspection.markAsAlreadyPaid
  </button>
</mat-dialog-actions>
